import profileHof from 'root/src/client/logic/creatorData/util/profileHof'

export default profileHof('description')
